import {sentinelMw} from '../api';
import environment from '../configs/environment.config';

export const submittingBrokerIdResource = {
    api: sentinelMw,
    url: 'viewgborefdata',
    useCache: !environment.testEnv,
    parseResponse: ({data}) => data.badges,
    defaultValue: []
};
